module.exports = __webpack_public_path__ + "static/Target_pin_hover-2546754bd6dfa35a5303bec292fd6573.png";